import React, {ReactNode} from 'react'
import {Box} from '@mui/material'
import styled from 'styled-components'
import {ErrorHandlingFormProps} from '../shared/forms/hoc/createErrorHandlingForm'
import {Colors, FontSize} from '../../styledComponents/Constants'
import {withErrorSubscribe} from '../shared/forms/hoc/withErrorSubscribe'
import FormErrorMessage from '../shared/forms/FormErrorMessage'
import {RowFlexContainer} from '../../styledComponents/FlexComponents'
import {getLinkIconComponent, IconBox} from '../assocDirector/AssocDirectorCommon'
import {getFileExtension} from '../../__NoAutomatedTests/common/util/Natutil'
import {Clear} from '@mui/icons-material'
import {currentMedia} from '../../styledComponents/ResponsiveConvenience'

export interface FileInformation {
    fileName: string
    fileData: string | ArrayBuffer | null
    fileIndex?: number
    fileNumber?: number | null
    deleteFlag?: boolean
}

interface Props {
    fileInformation?: FileInformation
    index: number
    inputProps?: React.InputHTMLAttributes<HTMLInputElement>
    onDelete?: (file: FileInformation) => void
}

class ResidentAttachmentFileArea
    extends React.Component<Props & ErrorHandlingFormProps> {

    constructor(props: Readonly<Props & ErrorHandlingFormProps>) {
        super(props)
        this.handleFileDelete = this.handleFileDelete.bind(this)
    }

    handleFileDelete(index: number): void {
        if (!this.props.onDelete) {
            return
        }
        this.props.onDelete(
            {
                fileName: '',
                fileData: '',
                fileIndex: index,
                fileNumber: null,
                deleteFlag: true
            }
        )
    }

    render(): ReactNode {
        const {fileInformation, index, messages} = this.props
        return <>
            <FileSelectDiv>
                {
                    (fileInformation !== undefined) &&
                    <>
                        <RowFlexContainer>
                            <AttachmentFileIconBox>
                                {getLinkIconComponent(getFileExtension(fileInformation.fileName))}
                            </AttachmentFileIconBox>
                            <AttachmentFileName>{fileInformation.fileName}</AttachmentFileName>
                            <Box flex={3} minWidth={'70px'}>
                                <FileDiv>
                                    <FileDelete onClick={() => {
                                        this.handleFileDelete(index)
                                    }}>
                                        <Clear style={clearIconStyle}/>取消
                                    </FileDelete>
                                </FileDiv>
                            </Box>
                        </RowFlexContainer>
                    </>
                }
                <InputField>
                    {
                        messages &&
                        <ErrorMessage
                            messages={messages.map((pair) => {
                                return {
                                    message: pair.message,
                                }
                            })}
                        />
                    }
                </InputField>
            </FileSelectDiv>
        </>
    }
}

const AttachmentFileIconBox = styled(IconBox)`
  color: ${Colors.AccentDark};
`

const AttachmentFileName = styled.label`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`

export const FileDiv = styled.div`
  text-align:right;
`

const ErrorMessage = styled(FormErrorMessage)`
  font-size: ${FontSize.Small} !important;
  font-family: "Noto Sans JP",sans-serif !important;
  color: ${Colors.Alert} !important;
`

const InputField = styled.div`
  display: flex;
  justify-content: center;
  margin: auto;
`

const clearIconStyle = {
    fontSize: FontSize.Big,
    color: Colors.Alert,
    verticalAlign: 'bottom',
}

const FileDelete = styled.a`
  color: ${Colors.Alert};
  line-height: 24px;
  font-weight: 112px;
  cursor: pointer;
`

const FileSelectDiv = styled.div`
  ${currentMedia.lessThan('sp')`
    margin-left: 18px;
    :nth-child(n+3) {
      padding-top: 20px;
    }
  `}
  ${currentMedia.greaterThan('pc')`
    :not(:first-child) {
      padding-top: 20px;
    }
  `}
`

export default withErrorSubscribe(ResidentAttachmentFileArea)